const meta = {
  'quotas-ui': 'View pools',
  'manage-pools': 'Manage pools',
};

export default meta;
